<!-- 批量录入推广链接-侧边栏 -->
<template>
<a-drawer
  title="添加推广链接"
  width="900px"
  placement="right"
  :closable="false"
  :visible="visible"
  @close="closeDrawer"
>
	<div class="form-cell-box">
		<div class="class-title">渠道</div>
			
		<a-select
			style="width: 620px;"
			placeholder="请选择小程序渠道"
			@change="handleChangeV"
			:filter-option="filterOption"
			:getPopupContainer="getsPopupContainer"
			:value="r_vd_qd"
			allowClear
		  >
			<a-select-option v-for="(value,key) in zhChannelSelect" :key="key" :value="key">
			  {{value}}
			</a-select-option>
		</a-select>
	</div>
	
	<div class="form-cell-box">
		<div class="class-title">小程序</div>
			
		<xcxSearchSelect ref="getXcxSelect" :mode_type="'dan'" :s_width="'620px'" @handleChangeSelect="handleChangeXCX"></xcxSearchSelect>
	</div>
	
	<div class="form-cell-box" style="align-items: baseline;">
		<div class="class-title">推广链接</div>
			
		<div>
			<div class="plEnterTgLink-table-input" style="padding: 10px 0;">
				<a-input @paste="plInputPasting" :value="pl_tg_input" 
				@change="plInputChange" placeholder="批量复制excel表的两列：推广链接ID    推广链接名称" />
			</div>
			
			<div style="border: 1px solid #e8e8e8;">
				<!-- 表头 -->
				<div class="table-th" >
					<div  v-for="(item,index) in rableTitle" :key="index" >
						<div class="table-th-cell"
						:style="{'width':item.width + 'px',}">
							{{item.title}}
						</div>
					</div>
					<div style="width: 50px;">
						
					</div>
				</div>
				<!-- 表格内容 -->
				<div v-for="(item,index) in tableShowData" :key="item.key" class="table-td" >
					
					<div class="table-td-cell"
					 :class="{'text-right': rableTitle[0].text_right}"
					:style="{'width':rableTitle[0].width + 'px'}">
						
						<!-- <div v-if="!item.input_control" @click="ldTitleClick(item)" style="min-height: 19px;cursor: pointer;">
							{{item.link_id}}
						</div>
						<a-input v-else @blur="LdTitleChange($event,item,index)" ref="title_input" :value="item.link_id" placeholder="请填写推广链接ID" /> -->
					
						<a-input v-model="item.link_id" placeholder="请填写推广链接ID" />
						
					</div>
					<div class="table-td-cell"
					 :class="{'text-right': rableTitle[1].text_right}"
					:style="{'width':rableTitle[1].width + 'px'}">
					
						<!-- <div v-if="!item.input_control_name" @click="ldTitleClick_name(item)" style="min-height: 19px;cursor: pointer;">
							{{item.link_name}}
						</div>
						<a-input v-else @blur="LdTitleChange_name($event,item,index)" ref="title_input" :value="item.link_name" placeholder="请填写推广链接名称" /> -->
					
						<a-input v-model="item.link_name" placeholder="请填写推广链接名称" />
					
					</div>
					
					<div style="width: 50px;text-align: center;">
						<a-icon @click="delTd(index)" style="padding: 5px;cursor: pointer;" type="close" />
					</div>
				</div>
				<a-button @click="addTgLink" type="primary" size="small" style="margin: 15px 19px;">
					添加
				</a-button>
				
			</div>
		</div>
	</div>
	
	<div class="form-cell-box" style="margin-top: 50px;padding-left: 41px;">
		<a-button @click="drawerRequest" :loading="drawer_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
		<a-button @click="closeDrawer">取消</a-button>
	</div>
</a-drawer>
</template>

<script>
import xcxSearchSelect from '@/components/selectCompont/xcxSearchSelect.vue'
import { putDataMenu, videoXcxPlTgLink } from '@/request/api'
export default {
	name: 'plEnterTgLink_',
	components: {
		xcxSearchSelect
	},
	props: [],
	data(){
		return {
			visible: false,
			drawer_button_loading: false,
			
			zhChannelSelect: [], // 小说小程序渠道+短剧渠道合并到一起
			r_vd_qd: undefined, // 小程序渠道
			r_appid: undefined, // 小程序
			
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"推广链接ID", width:240, type:"link_id", },
				{title:"推广链接名称", width:330, type:"link_name", },
			],
			tableShowData: [],
			
			pl_tg_input: null,
		}
	},
	mounted(){
		let that = this
		putDataMenu().then(res=>{
			console.log("获取搜索条件",res);
			
			let f_select = res.data.data.filter
			that.zhChannelSelect = { ...f_select.vd_channel.list, ...f_select.mp_book_channel.list }
		})
	},
	methods: {
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 小程序渠道
		handleChangeV(e){
			this.r_vd_qd = e
			// 获取小程序下拉
			this.$refs.getXcxSelect.getSelectData(e)
		},
		// 小程序
		handleChangeXCX(e){
			this.r_appid = e
		},
		getShowDrawer(){
			let that = this
			this.visible = true
			
			that.$nextTick(()=>{
				// 获取小程序下拉
				that.$refs.getXcxSelect.getSelectData()
				// that.$refs.getXcxSelect.setValue(this.e_appid)
			})
		},
		drawerRequest(){
			let that = this
			
			if(!that.r_vd_qd){
				that.$message.warning('请先选择渠道');
				return
			}
			else if(!that.r_appid){
				that.$message.warning('请先选择小程序');
				return
			}
			else if(that.tableShowData.length == 0){
				that.$message.warning('请先添加推广链接');
				return
			}
			
			// 判断里面内容是否有空
			for(let i = 0; i < that.tableShowData.length; i++) {
				let res = that.tableShowData[i]
				if(!res.link_id){
					that.$message.warning('推广链接ID不能为空');
					return
				}
				else if(!res.link_name){
					that.$message.warning('推广链接名称不能为空');
					return
				}
			}
			
			
			let l_data = []
			// 数组对象去重，避免有重复的link_id
			let obj = {};
			l_data = that.tableShowData.reduce(function(item, next) {
			   obj[next.link_id] ? '' : obj[next.link_id] = true && item.push(next);
			   return item;
			}, []);
			console.log("l_data",l_data);
			
			
			that.drawer_button_loading = true
			
			let r_data = {
				link_ids: l_data,
				channel: that.r_vd_qd,
				appid: that.r_appid,
			}
			videoXcxPlTgLink(r_data).then(res=>{
				console.log("添加",res);
				that.drawer_button_loading = false
				if(res.data.code == 0 || res.data.code == 200){
					that.$message.success(res.data.msg);
					that.closeDrawer()
					that.$emit("pl-tg-link-ok",'')
				}
				else {
					that.$message.error(`错误：${res.data.msg}`);
				}
			})
		},
		closeDrawer(){
			this.$refs.getXcxSelect.setValue(undefined)
			this.visible = false
			this.drawer_button_loading = false
			
			this.tableShowData = []
			this.r_vd_qd = undefined
			this.r_appid = undefined
		},
		
		
		plInputPasting(e){
			let that = this
			
			// console.log("粘贴",e.clipboardData.getData('Text'))
			let aaa = e.clipboardData.getData('Text')
			
			// 一行有两列数据，所以这里要先把数据 一行一行分开
			let sss = aaa.split(/[\r\n]+/)
			// console.log("sss",sss)
			
			let ddd = []
			// 这一步是为了避免，有空内容，有的情况会出现，有的时候不会
			sss.forEach(res=>{
				if(res){
					ddd.push(res)
				}
			})
			// console.log("ddd",ddd)
			let tt_arr = []
			ddd.forEach((res,index)=>{
				// console.log("res",res)
				let obj = {
					link_id: "",
					link_name: "",
					key: `${index}_${Math.round(Math.random()*10)}_${new Date().getTime()}`, // index索引+随机数+时间戳
					input_control: false,
					input_control_name: false,
				}
				// 在把每一行的数据，一列一列分开
				let ccc = res.split(/[\t\s]+/)
				// console.log("ccc",ccc)
				obj.link_id = ccc[0] || ""
				obj.link_name = ccc[1] || ""
				
				tt_arr.push(obj)
			})
			// console.log("tt_arr",tt_arr)
			this.tableShowData = this.tableShowData.concat(tt_arr)
			this.pl_tg_input = null
		},
		plInputChange(e){
			console.log("变化",e)
			this.pl_tg_input = null
		},
		
		delTd(index){
			console.log("index",index)
			this.tableShowData.splice(index,1)
		},
		addTgLink(){
			let that = this
			let tt_arr = []
			let obj = {
				link_id: "",
				link_name: "",
				key: `${this.tableShowData.length}_${Math.round(Math.random()*10)}_${new Date().getTime()}`, // index索引+随机数+时间戳
				input_control: true,
				input_control_name: true,
			}
			console.log("obj",obj)
			tt_arr.push(obj)
			this.tableShowData = this.tableShowData.concat(tt_arr)
		},
		
		// 点击推广链接ID展示输入框
		ldTitleClick(item){
			// console.log('点击表格内容展示输入框',item);
			item.input_control = !item.input_control
			this.$nextTick(() => {
				this.$refs.title_input[0].focus()
			})
		},
		// 点击推广链接名字展示输入框
		ldTitleClick_name(item){
			// console.log('点击表格内容展示输入框',item);
			item.input_control_name = !item.input_control_name
			this.$nextTick(() => {
				this.$refs.title_input[0].focus()
			})
		},
		// 推广链接ID输入框失去焦点
		LdTitleChange(e,item,index){
			let that = this
			
			item.input_control = false
			that.tableShowData[index].link_id = e.target.value
		},
		LdTitleChange_name(e,item,index){
			let that = this
			
			item.input_control_name = false
			that.tableShowData[index].link_name = e.target.value
		},
	}
}
</script>

<style scoped>
	.form-cell-box{
		margin-bottom: 20px;
	}
	
	.table-input input {
		outline: none;
	}
	
	.table-td-cell {
		padding-left: 20px;
		padding-right: 1px;
	}
	.table-th-cell {
		padding-left: 20px;
		padding-right: 1px;
	}
	.table-th {
		top: 0;
	}
</style>